import {
  faAngleLeft,
  faArrowRight,
  faCalendar,
  faCopy,
  faLayerGroup,
  faPencil,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { Button, Dropdown } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import style from "./MySignature.module.css";
import parse from "html-react-parser";
import { toast } from "react-toastify";
import {
  faEdit,
  faPlusSquare,
  faTrashAlt,
} from "@fortawesome/free-regular-svg-icons";
import { Pagination, Tooltip } from "@mui/material";
import usePagination from "../customPagination/pag1";
import lang from "../../../assets/lang/toastMsg.json";
import BodyLoading from "../Loading/BodyLoading";
import PopUpModal from "../Modal/PopUpModal";
import Pro from "./../Pro/Pro";
import routes from "../../../assets/lang/routes";
import ConfirmationModal from "../ConfirmationModal/ConfirmationModal";

export default function MySignature() {
  const [allSignatures, setAllSignatures] = useState([]);
  // const [render, setRender] = useState("");
  const [loading, setLoading] = useState(true);
  const [checkStorage, setCheckStorage] = useState(
    localStorage.getItem("auth_token") ? true : false
  );

  // confirmation modal
  const [showConfimrationModal, setShowConfirmationModal] = useState(false);
  const [confirmText, setConfirmText] = useState("");
  const [confirmButtonText, setConfirmButtonText] = useState("false");

  //toggle sidbar
  const [toggleSiebar, setToggleSiebar] = useState(false);

  // Rename Template
  const [userTemplateName, setUserTemplateName] = useState("Template");
  const [userTemplateID, setUserTemplateId] = useState("");
  const [renameShow, setRenameShow] = useState(false);

  const handleRenameClose = () => {
    setRenameShow(false);
  };
  const handleRenameShow = (e) => {
    e.preventDefault();
    setRenameShow(true);
    setUserTemplateName(e.target.getAttribute("data-temp-name"));
    setUserTemplateId(e.target.getAttribute("data-id"));
  };

  //pagination
  let [page, setPage] = useState(1);
  const PER_PAGE = 2;

  const count = Math.ceil(allSignatures.length / PER_PAGE);
  const _DATA = usePagination(allSignatures, PER_PAGE);

  const handleChange = (e, p) => {
    setPage(p);
    _DATA.jump(p);
  };
  const navigate = useNavigate();

  //edit template
  const hadnleEditTemplate = async (e) => {
    e.preventDefault();
    try {
      // setLoading(true);
      const tempId = {
        tempId: Number(e.target.getAttribute("data-id")),
      };

      const response = await axios.post("/edit-user-template", tempId);

      if (response.data.status === 200) {
        navigate("/editor");
      } else {
        console.log("issue");
      }
      // setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  //delete template
  const deleteTemp = async (e, id) => {
    e.preventDefault();

    // if (!showConfimrationModal) {
    //   setShowConfirmationModal(true);
    // } else {
    try {
      setLoading(true);
      setPage(1);
      _DATA.jump(1);

      const response = await axios.get("/deleteTemp/" + id);
      // setRender(true);
      fetchData();
      if (response.data.status === 200) {
        toast.success(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      } else {
        toast.error(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
    // }
  };

  //rename template
  const handleSigRename = (e) => {
    e.preventDefault();

    // call api to rename the current template
    setUserTemplateName(e.target.value);
  };

  const Rename = async (e) => {
    e.preventDefault();

    try {
      setLoading(true);
      const response = await axios.post(
        "/renameTemp/" + userTemplateID,
        userTemplateName
      );

      setRenameShow(false);

      // setRender(true);
      if (response.data.status === 200) {
        fetchData();
        toast.success(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      } else {
        toast.error(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  //duplicate template
  const Duplicate = async (e, id) => {
    e.preventDefault();

    try {
      setLoading(true);
      const response = await axios.post("/duplicate-template", id);
      // setRender(true);
      if (response.data.status === 200) {
        fetchData();
        toast.success(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      } else {
        toast.error(response.data.message, {
          closeOnClick: true,
          theme: "colored",
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  //copy siganture of current template
  const copySignature = (e) => {
    e.preventDefault();
    copyToClipboard(e.target.getAttribute("data-html"));
    toast.dismiss();
    toast.success(`${lang.sigCopyToClipboard}`, {
      closeOnClick: true,
      theme: "colored",
    });
  };

  function copyToClipboard(html) {
    var container = document.createElement("div");
    container.innerHTML = html;
    container.style.position = "fixed";
    container.style.pointerEvents = "none";
    container.style.opacity = 0;
    document.body.appendChild(container);
    window.getSelection().removeAllRanges();
    var range = document.createRange();
    range.selectNode(container);
    window.getSelection().addRange(range);
    document.execCommand("copy");
    document.body.removeChild(container);
  }

  //toggle sidebar
  const sidebarToggle = () => {
    toggleSiebar ? setToggleSiebar(false) : setToggleSiebar(true);
  };

  const fetchData = async () => {
    try {
      setLoading(true);
      const response = await axios.get("/getalltemps");
      if (response.data.status === 200) {
        setAllSignatures(response.data.temps);
      } else {
        console.log(response.data);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    // setRender(false);
    fetchData();
  }, []);

  useEffect(() => {
    document.title = "My Signature";

    function handleStorage() {
      setCheckStorage(localStorage.getItem("auth_token") ? true : false);
    }
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, [checkStorage]);

  return (
    <div className={`${style.mainContent} `}>
      <div
        className={`${style.mySignatureSidebar} ${
          toggleSiebar ? `${style.collapsed}` : `${style.collapse}`
        }`}
      >
        <div
          className={`${style.mySignatureToggle} ${
            toggleSiebar ? `${style.collapsed}` : `${style.collapse}`
          }`}
          onClick={sidebarToggle}
        >
          <FontAwesomeIcon icon={faAngleLeft} />
        </div>
        <div className={`${style.sidebarNav}`}>
          <div className={`${style.Navbtn}`}>
            <Link
              href={`${routes.mySignature}`}
              className={`${style.navRoute} ${style.active} ${
                toggleSiebar ? `${style.collapsed}` : `${style.collapse}`
              }`}
            >
              <div className="icons">
                {toggleSiebar ? (
                  <Tooltip
                    title={
                      <span style={{ fontSize: "16px" }}>My Signatures</span>
                    }
                    placement="right"
                  >
                    <FontAwesomeIcon icon={faLayerGroup} className=" me-1" />
                  </Tooltip>
                ) : (
                  <FontAwesomeIcon icon={faLayerGroup} className=" me-1" />
                )}
              </div>
              <span> {!toggleSiebar ? "My Signatures" : null}</span>
            </Link>
          </div>

          <div className={`${style.Navbtn}`}>
            <Link
              to={`${routes.editor}`}
              className={`${style.navRoute} ${
                toggleSiebar ? `${style.collapsed}` : `${style.collapse}`
              } `}
            >
              <div className="icons">
                {toggleSiebar ? (
                  <Tooltip
                    title={<span style={{ fontSize: "16px" }}>Editor</span>}
                    placement="right"
                  >
                    <FontAwesomeIcon icon={faCalendar} className=" me-1" />
                  </Tooltip>
                ) : (
                  <FontAwesomeIcon icon={faCalendar} className=" me-1" />
                )}
              </div>
              <span> {!toggleSiebar ? "Editor" : null}</span>
            </Link>
          </div>
        </div>
      </div>
      <div
        className={` p-3 bg-orange text-white ${style.mySignatureMainContent} ${
          toggleSiebar ? `${style.collapsed}` : `${style.collapse}`
        }`}
      >
        <div className="row">
          <div className="col-xxl-9 col-8 ">
            {loading ? (
              <BodyLoading />
            ) : (
              <>
                <div className={`${style.mySignatureTitle}`}>
                  My Signatures
                  {allSignatures.length > 0 ? `[${allSignatures.length}]` : ""}
                </div>
                <div className={`${style.signatureItems}`}>
                  {allSignatures.length > 0 ? (
                    _DATA.currentData().map((template) => (
                      <div
                        className={`${style.signatureItem}`}
                        key={template.id}
                      >
                        <div className={`${style.signatureItemHeader} `}>
                          {template.user_template_name}
                        </div>
                        <div className={`${style.signatureBody} py-3`}>
                          {parse(template.html)}
                        </div>
                        <div className={`${style.signatureFooterItem} `}>
                          <div className={`${style.signatureFooterWrapper}`}>
                            <div className={`${style.signatureFooterItemOne}`}>
                              <button
                                className="signature-item-edit-btn btn btn-secondary px-5"
                                data-id={template.id}
                                onClick={hadnleEditTemplate}
                              >
                                <FontAwesomeIcon
                                  icon={faPencil}
                                  className="me-1"
                                />
                                Edit
                              </button>
                              {/* <button
                                  className="signature-item-edit-btn btn btn-primary d-flex align-items-center ms-3"
                                  data-html={template.html}
                                  onClick={copySignature}
                                >
                                  Copy Signature <Pro marginValue="5px" />
                                </button> */}
                            </div>
                            <div
                              className={`${style.signatureFooterItemTwo} justify-content-center`}
                            ></div>
                            <div
                              className={`${style.signatureFooterItemThree} justify-content-end`}
                            >
                              <Dropdown
                                className={`${style.dropdown} ms-3`}
                                rendermenuonmount="true"
                                id={template.id}
                              >
                                <Dropdown.Toggle
                                  variant="outline-light"
                                  id="dropdown-basic"
                                  className={`${style.signatureFooterActionBtn} border-info d-flex align-items-center`}
                                >
                                  <span
                                    className={`${style.signatureItemActionsBtnIcon}`}
                                  >
                                    <span
                                      className={`${style.signatureItemActionsBtnDot}`}
                                    ></span>
                                    <span
                                      className={`${style.signatureItemActionsBtnDot}`}
                                    ></span>
                                    <span
                                      className={`${style.signatureItemActionsBtnDot}`}
                                    ></span>
                                  </span>
                                  <span className="signature-item-actions-btn-text text-info">
                                    Actions
                                  </span>
                                </Dropdown.Toggle>

                                <Dropdown.Menu
                                  className={`${style.dropdownMenu} p-2 border-0 shadow`}
                                >
                                  <Dropdown.Item
                                    as="button"
                                    className={`${style.dropdownItem} py-2 `}
                                    data-id={`${template.id}`}
                                    data-temp-name={`${template.user_template_name}`}
                                    onClick={handleRenameShow}
                                  >
                                    <FontAwesomeIcon
                                      icon={faEdit}
                                      className="me-2"
                                    />
                                    Rename
                                  </Dropdown.Item>

                                  <Dropdown.Item
                                    as="button"
                                    className={`${style.dropdownItem} py-2 `}
                                    onClick={(e) => Duplicate(e, template.id)}
                                  >
                                    <FontAwesomeIcon
                                      icon={faCopy}
                                      className="me-2"
                                    />
                                    Duplicate <Pro />
                                  </Dropdown.Item>

                                  <Dropdown.Item
                                    as="button"
                                    className={`${style.dropdownItem} py-2 `}
                                    onClick={(e) => deleteTemp(e, template.id)}
                                  >
                                    <FontAwesomeIcon
                                      icon={faTrashAlt}
                                      className="me-2"
                                    />
                                    Delete
                                  </Dropdown.Item>
                                </Dropdown.Menu>
                              </Dropdown>

                              {renameShow ? (
                                <PopUpModal
                                  title={"Choose Signature Title"}
                                  setmodalstate={setRenameShow}
                                  showFooter={false}
                                >
                                  <div className="d-flex align-items-center flex-column">
                                    <input
                                      type="text"
                                      name="userTemplateName"
                                      value={userTemplateName}
                                      className="p-1 w-100"
                                      onChange={handleSigRename}
                                    />
                                    <Button
                                      className="text-light w-100 mt-4"
                                      onClick={Rename}
                                    >
                                      Rename Signature
                                    </Button>
                                    <Button
                                      className="w-100 btn btn-outline-secondary mt-2"
                                      onClick={handleRenameClose}
                                    >
                                      Close
                                    </Button>
                                  </div>
                                </PopUpModal>
                              ) : null}

                              {/* <button className="signature-item-edit-btn btn btn-primary  ms-3">Install</button> */}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <Link
                      to="/editor"
                      className="signature-item d-block text-decoration-none"
                      style={{
                        background: "#fff",
                        cursor: "pointer",
                        border: "1px dashed skyblue",
                      }}
                    >
                      <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ height: "150px" }}
                      >
                        <p className="text-info fw-bold">
                          <FontAwesomeIcon
                            color="dark"
                            icon={faPlusSquare}
                            size="lg"
                            className="me-2"
                          />
                          Create New Signature
                        </p>
                      </div>
                    </Link>
                  )}
                </div>
                {allSignatures.length > PER_PAGE ? (
                  <Pagination
                    count={count}
                    size="large"
                    page={page}
                    color="info"
                    shape="rounded"
                    onChange={handleChange}
                    className={`${style.pagination}`}
                  />
                ) : null}
              </>
            )}
          </div>

          <div className="col-xxl-3 col-4 ">
            <div className="my-signature-setting">
              <div className={`${style.mySignatureSettingText} text-info`}>
                {/* <Link className="text-decoration-none text-info" onClick={handleSignatureSetting}>< FontAwesomeIcon icon={faGear} className=' me-1' />Signatures settings</Link> */}
              </div>
              <div className={`${style.upgradeBox} bg-blue`}>
                <div className="upgrade-box-content">
                  <div className={`${style.upgradeBoxTitle}`}>
                    Take your signature to the next level
                  </div>
                  <div className="upgrade-box-features">
                    <div className={`${style.upgradeBoxFeature}`}>
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="text-danger me-3"
                      />
                      Premium Templates
                    </div>
                    <div className={`${style.upgradeBoxFeature}`}>
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="text-danger me-3"
                      />
                      Advanced style & design
                    </div>
                    <div className={`${style.upgradeBoxFeature}`}>
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="text-danger me-3"
                      />
                      Unlimited signatures for you
                    </div>
                    <div className={`${style.upgradeBoxFeature}`}>
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="text-danger me-3"
                      />
                      Unlimited Templates for you
                    </div>
                    <div className={`${style.upgradeBoxFeature}`}>
                      <FontAwesomeIcon
                        icon={faArrowRight}
                        className="text-danger me-3"
                      />
                      Duplicate Unlimited Templates
                    </div>
                  </div>
                  <div className={`${style.upgradeBoxButtons}`}>
                    <button className="btn btn-secondary">
                      Upgrade to PRO
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* <ConfirmationModal
        showModal={showConfimrationModal}
        setModalState={(e) => setShowConfirmationModal(e)}
        title={`Confirm`}
        description={confirmText}
        confirmed={actionConfirmed}
        confirmButtonText={confirmButtonText}
      /> */}
    </div>
  );
}
